<template>
  <div>
    <h1 class="page-header">
      Branch Profile
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-6">
            <ts-button color="info" outline @click="$router.push({ name: 'branch-create' })">
              Add New
            </ts-button>
          </div>
          <div class="col-sm-6 d-flex justify-content-end">
            <ts-input v-model="search" placeholder="Search" style="width: 300px;" />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template slot-scope="{ record }">
            <td class="kh-font">{{ record.company.company_name_kh }}</td>
            <td>{{ record.company.company_name_en }}</td>
            <td class="kh-font">{{ record.branch_name_kh }}</td>
            <td>{{ record.branch_name_en }}</td>
            <td class="text-center">{{ record.branch_code }}</td>
            <td class="kh-font">{{ record.branch_phone }}</td>
            <td class="kh-font">{{ record.branch_email }}</td>
            <td class="kh-font">{{ record.branch_address }}</td>
            <td class="text-center">
              <router-link :to="{ name: 'branch-edit', params: { id: record.branch_id } }" title="edit" class="mr-2">
                <i class="fas fa-edit"></i>
              </router-link>
              <a href="#" title="delete" class="text-danger" @click.prevent="destroyBranch(record.branch_id)">
                <i class="fas fa-trash"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" :query="{ search }" @navigate="fetchData"> </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'branch',
  data() {
    return {
      loading: false,
      columns: [
        { name: 'company name kh' },
        { name: 'company name En' },
        { name: 'branch name kh' },
        { name: 'branch name En' },
        { name: 'branch code', style: 'text-align:center' },
        { name: 'phone number' },
        { name: 'email' },
        { name: 'addresss' },
        { name: 'actions', style: 'text-align:center' }
      ]
    }
  },
  created() {
    this.fetchData()
  },

  computed: {
    ...mapState('administration/branch', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administration.branch.search
      },
      set(newValue) {
        this.$store.commit('administration.branch/SET_SEARCH', newValue)
        this.$store.commit('administration.branch/RESET_CURRENT_PAGE')
      }
    }
  },

  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administration/branch/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async destroyBranch(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('administration/branch/destroy', id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'branch-create') {
      this.$store.commit('administration/branch/RESET_STATE')
    }
    next()
  }
}
</script>
